export enum PretaxAccountType {
  FSA = 'fsa',
  // HRA = 'hra',
  HSA = 'hsa',
  DEDUCTIBLE = 'deductible',
  OTHER = 'other',
  // VEBA = 'veba',
  TRANSIT = 'transit',
  TRANSIT_TYPE = 'trn',
  PARKING_TYPE = 'pkg',
  PARKING = 'parking',
  LPFSA = 'lpfsa',
  LPFSAHSA = 'LPFSAHSA', // a combined account of HSA and LPFSA done only in FE
  WCS = 'wcs', //alegues code for HSA
  LPF = 'lpf', //alegeus code for LPFSA
  DCFSA = 'dca',
}

// source of truth: PretaxPlanType
// https://github.com/joinforma/pretax-services/blob/608afd893a3c73fa5ab93085b3df749f3d5d7e60/libs/accounts-domain/src/constants.ts
// TODO: rename this to `PretaxAccountType` after we migrated to new pretax experience
export enum PretaxAccountV2Type {
  FSA = 'fsa',
  HSA = 'hsa',
  DCFSA = 'dcfsa',
  LPFSA = 'lpfsa',
  TRANSIT = 'transit',
  PARKING = 'parking',
}

export enum PretaxAccountFullName {
  DCFSA = 'Dependent Care Flexible Spending Account',
  LPFSA = 'Limited Purpose Flexible Spending Account',
  FSA = 'Flexible Spending Account',
  HSA = 'Health Savings Account',
}

export enum FsaStorePretaxAccountType {
  FSA = 'FSA',
  HSA = 'HSA',
  WCS = 'WCS', //alegues code for HSA
  LPF = 'LPF', //alegeus code for LPFSA
  LPFSA = 'LPFSA',
  LPFSAHSA = 'LPFSAHSA', // a combined account of HSA and LPFSA done only in FE
  LFS = 'LFS', //only use for staging mock DB, no such account exist on Prod,
}

export enum PretaxAccountStatus {
  ACTIVE = 'Active',
  NEW = 'New',
  PENDING = 'Pending',
  TERMINATED = 'Terminated',
  TEMP_INACTIVE = 'TempInactive',
}

export enum PretaxWalletStatus {
  // source: https://github.com/joinforma/pretax-services/blob/b2d23044184b1cde1f1b48cc5f7783ec4e5c790b/libs/accounts-domain/src/constants.ts#L58
  ACTIVE = 'active',
  TEMPORARILY_INACTIVE = 'temporarily_inactive',
  PERMANENTLY_INACTIVE = 'permanently_inactive',
  TERMINATED = 'terminated',
  ACTIVE__TO_BE_TRANSFERRED = 'active__to_be_transferred',
}

export enum PretaxAccountName {
  TRANSIT = 'Commuter Transit',
  PARKING = 'Commuter Parking',
  FSA = 'FSA',
  HSA = 'HSA',
  LPFSAHSA = 'Limited Purpose FSA & HSA', // a combined account of HSA and LPFSA done only in FE
  WCS = 'HSA', //alegues code for HSA
  LPF = 'LPFSA', //alegeus code for LPFSA
}

export const ENDLESS_PRETAX_ACCOUNT_TYPE = Object.freeze([
  // Account types that we treat the plan without preset end date
  PretaxAccountType.TRANSIT,
  PretaxAccountType.PARKING,
  PretaxAccountType.HSA,
  PretaxAccountType.WCS,
]);

/**
 * Compiled from:
 * https://github.com/joinforma/twicapp-services/blob/main/services/api-service/src/plugins/employee/src/routes/v2/util/wallet.js#L7
 */
export enum TwicAccountType {
  BIKING = 'biking',
  COMMUNICATION = 'communication',
  COMMUNICATIONS = 'communications',
  COMMUTER = 'commuter',
  CUSTOM = 'custom',
  CUSTOM2 = 'custom_2',
  FAMILY = 'family',
  FAMILY_FORMATION = 'family_formation',
  FOOD = 'food',
  HEALTH_CHECK = 'health_check',
  LEARNING = 'learning',
  LIFESTYLE = 'lifestyle',
  MENTAL_HEALTH = 'mental_health',
  PET = 'pet',
  REWARDS = 'rewards',
  TEAM_BUILDING = 'team_building',
  WELLNESS = 'wellness',
  WORK_FROM_HOME = 'work_from_home',
  VISION_PROTECTION = 'vision_protection',
}

//pretax v1 categories until all pretax are migrated off of Alegeus
export const DEFAULT_PRETAX_CATEGORIES = [
  'Dental',
  'Medical',
  'Pharmacy',
  'Vision',
  'OTC',
];

export const LPFSA_PRETAX_CATEGORIES = ['Dental', 'Vision'];

export const TRANSIT_CATEGORIES = ['Public Transit', 'Vanpool', 'Ferry'];
export const PARKING_CATEGORIES = ['Parking'];
export const DEPENDENT_CARE_CATEGORIES = [
  'Child Care',
  'Child Education',
  'Adult Care',
];

export const TWIC_PRETAX_STORES_CONSTANTS = Object.freeze({
  AMAZON: {
    NAME: 'Amazon',
    LINK: 'https://www.amazon.com/FSA-Store/b?ie=UTF8&node=17904040011',
    DESCRIPTION: `Amazon's FSA/HSA store makes shopping easy - just add your Benefits card and shop!`,
    LOGOHEIGHT: '65px',
    LOGOWIDTH: '145px',
  },
  CVS: {
    NAME: 'CVS',
    LINK: 'https://www.cvs.com/shop/content/FSA',
    DESCRIPTION:
      'Shop CVS’s assortment of items available for purchase with your HSA/FSA dollars.',
    LOGOHEIGHT: '70px',
    LOGOWIDTH: '176px',
  },
  FSASTORE: {
    NAME: 'FSAStore',
    LINK: 'https://fsastore.com/insiders.html?AFID=490885&ParentId=TWIC&GroupName={AS:Serving:CustomEncoded2}&CID={AS:Serving:CustomEncoded3}&utm_source={AS:Serving:CustomEncoded6}&utm_medium={AS:Serving:CustomEncoded7}&utm_campaign={AS:Serving:CustomEncoded8}&TP=1',
    DESCRIPTION:
      'The FSAStore is a marketplace for 100% FSA-eligible products.',
    LOGOHEIGHT: '70px',
    LOGOWIDTH: '203px',
  },
  HSASTORE: {
    NAME: 'HSAStore',
    LINK: 'https://hsastore.com/insiders.html?AFID=490885&ParentId=TWIC&GroupName={AS:Serving:CustomEncoded2}&CID={AS:Serving:CustomEncoded3}&utm_source={AS:Serving:CustomEncoded6}&utm_medium={AS:Serving:CustomEncoded7}&utm_campaign={AS:Serving:CustomEncoded8}',
    DESCRIPTION:
      'The HSAstore provides a selection of guaranteed HSA eligible products',
    LOGOHEIGHT: '70px',
    LOGOWIDTH: '203px',
  },
  WALGREENS: {
    NAME: 'Walgreens',
    LINK: 'https://www.walgreens.com/topic/store/fsa/shop_fsa.jsp',
    DESCRIPTION:
      'Shop in store or online at Walgreens with your card for FSA-eligible items',
    LOGOHEIGHT: '70px',
    LOGOWIDTH: '160px',
  },
});

export const PRETAX_COMMUTER_ACCOUNT_TYPES = ['Transit', 'Parking'];

export const PRETAX_HSA_ACCOUNT_TYPES = ['HSA', 'WCS', 'LPFSAHSA'];

// TODO(dabo): reading this from backend in M2
export const PRETAX_COMMUTER_2022_IRS_LIMIT = 280;

// According to law, we only allow election by monthly basis
export const PRETAX_COMMUTER_ELECTION_FREQUENCY = 'monthly';

export enum HSACoverageTier {
  SINGLE = 'single',
  FAMILY = 'family',
}

export const IRS_HSA_MAX_YEARLY_ELECTION_AMOUNT_FAMILY = 7750;
export const IRS_HSA_MAX_YEARLY_ELECTION_AMOUNT_SINGLE = 3850;

export const ENROLL_PENDING_PRETAX_COMMUTER_ACCOUNT = Object.freeze({
  account_display_header: 'Commuter',
  account_type_class_code: PretaxAccountType.OTHER,
  account_status_code: PretaxAccountStatus.PENDING,
  flex_account_id: 'ENROLL_PENDING_COMMUTER_ACCOUNT',
  account_detail_info: {
    available_balance: 0,
  },
});

export enum PretaxCommuterEnrollStatus {
  SELECTION_DISABLED = 'selection_disabled',
  SELECTION_FINISHED = 'selection_finished',
  SELECTION_PENDING = 'selection_pending',
  SELECTION_WAIVED = 'selection_waived',
}

export enum AccountRenewalFrequency {
  ANNUALLY = 'annually',
  SEMIANNUALLY = 'semiannually',
  SEMIANNUAL = 'semi-annually',
  QUARTERLY = 'quarterly',
  MONTHLY = 'monthly',
  WEEKLY = 'weekly',
  DAILY = 'daily',
  NEVER = 'never',
}

export const ALEGEUS_HSA = 'alegeus-hsa';
